import { render, staticRenderFns } from "./TaskFilter.vue?vue&type=template&id=e8356120&"
import script from "./TaskFilter.vue?vue&type=script&lang=js&"
export * from "./TaskFilter.vue?vue&type=script&lang=js&"
import style0 from "./TaskFilter.vue?vue&type=style&index=0&id=e8356120&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports